<script setup>

import { computed, defineProps} from "vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "pedidoDeCompra"
]);

//==================================================================//
//======================= Aprovadores Header =======================//
//==================================================================//

let aprovadoresHeaders = [
    { text: 'Codigo da Aprovação',      value: 'codigo',            class:"c-parcelas__header",    cellClass:'c-parcelas__cell', width:"88px"},
    { text: 'Decisão',                  value: 'decisao',           class:"c-parcelas__header",    cellClass:'c-parcelas__cell', width:"180px"},
    { text: 'Aprovador',                value: 'aprovador.nome',    class:"c-parcelas__header",    cellClass:'c-parcelas__cell', width:"180px"},
    { text: 'Data Decisão',             value: 'dataDecisao',       class:"c-parcelas__header",    cellClass:'c-parcelas__cell', width:"180px"},
]

//==================================================================//
//========================== Compradores ===========================//
//==================================================================//

const compradores = computed(()=>{

    return props?.pedidoDeCompra?.aprovadores?.reduce((acc,aprovador)=>{

        if(aprovador.tipo == "Comprador"){
            acc.push(aprovador);
        }

        return acc;

    },[]);

});

//==================================================================//
//========================= Cor Decisao ==========================//
//==================================================================//

const corDecisao = (item) =>{

    if(item?.decisao == "Aprovou"){

        return "green"

    }else if( item?.decisao == "Reprovou"){

        return "red"

    }else{

        return "gray"

    }

};

//==================================================================//
//========================= Icone Decisao ==========================//
//==================================================================//

const iconeDecisao = (item) =>{

    if(item?.decisao == "Aprovou"){

        return "mdi-check-circle"

    }else if( item?.decisao == "Reprovou"){

        return "mdi-close-circle"

    }else{

        return "mdi-circle"

    }

};

//==================================================================//
//========================== Data Decisao ==========================//
//==================================================================//

const dataDecisao = (item) =>{

    if(!item?.dataDecisao){
        return "--/--/----"
    }

    return item?.dataDecisao;

}

</script>

<template>

    <v-card
        class="c-aprovadores"
    >

        <v-card-title
            class="c-aprovadores__titulo"
        >
        
            <h3>Aprovador</h3>

        </v-card-title>

        <div
            class="c-aprovadores__conteudo"
        >

            <v-data-table
                class="c-aprovadores__tabela elevation-1"
                :headers="aprovadoresHeaders"
                :items="compradores"
                :items-per-page="-1"
                item-key="id"
            >

                <template v-slot:item.decisao="{item}">

                    <v-icon
                        :color="corDecisao(item)"
                        large
                    >
                        {{iconeDecisao(item)}}
                    </v-icon>

                </template>

                <template v-slot:item.dataDecisao="{item}">

                    {{ dataDecisao(item) }}
                
                </template>

            </v-data-table>

        </div>

    </v-card>


</template>

<style scoped>

.c-campo{
    pointer-events: none;
}

.c-aprovadores__tabela{
    display: grid;
    white-space: nowrap;
}

</style>